class LoadBar extends Phaser.Group {
  constructor(game) {
    super(game);

    // create load bar
    this.track = this.game.make.image();
    this.track.loadTexture('loader', 'cn_preloader_bar.png');
    this.track.x = -(this.track.width * 0.5);
    // this.track.anchor.set(0.5);

    this.fill = this.game.make.image(0, 10);
    this.fill.loadTexture('loader', 'cn_preloader_pattern.jpg');
    this.track.addChild(this.fill);

    this.masker = this.game.make.graphics();
    this.masker.beginFill(0x000000);
    this.masker.drawRect(0, 0, this.fill.width, this.fill.height);
    this.masker.x = this.fill.x - this.fill.width * 0.5;
    this.masker.y = this.fill.y;

    this.add(this.fill);
    this.add(this.masker);
    this.add(this.track);

    this.loadPosition = -128;
    this.loadOffset = 0;

    // this.temp = 50 / 100;
  }

  update() {
    // this.temp += 0.0001;
    this.loadOffset += 5;
    // this.setProgress(this.temp);
    this.fill.x = (this.loadOffset % 128) + this.loadPosition - this.fill.width * 0.4;
  }

  setProgress(value) {
    this.masker.x = this.fill.width * value - this.fill.width * 0.5;
    // value = value === 0 ? 0.001 : value;
    //this.masker.scale.x = value;
  }
}
export default LoadBar;
